import { fetchers } from '@pes-ui/utils';
import { TLocaleObj } from 'src/utils/types';
export class RelatedProductsStore {
  productsGroupMap = {}

  //   /**
  //    * @type {any}
  //    */
  relatedProducts

  localeObj: TLocaleObj = {
    countryCode: '',
    languageCode: ''
  }
  productId: string;
  siteType: string;
  //   /**
  //    * @param {string} productId
  //    * @param {'b2b' | 'b2c'} siteType
  //    */
  constructor(productId, siteType, localeObj) {
    this.productId = productId;
    this.siteType = siteType;
    this.localeObj = localeObj
  }

  getRelatedGroups = async () => {
    if (this.relatedProducts) {
      return this.relatedProducts;
    }

    const { countryCode, languageCode } = this.localeObj;
    try {    
      const { error, relatedProductsResponse: relatedProducts } = await fetchers.getRelatedProducts({
        countryCode,
        languageCode,
        productId: this.productId
      });

      if (error) throw error;
       // Mapping related Products
      const { info, services, software } = relatedProducts;
      this.relatedProducts = this.relatedProductToRelatedProductInfo(relatedProducts);
      const servicesData = services ? { [services.groupId]: services }: {};
      const softwareData = software ? { [software.groupId]: software }: {};
      const relatedProductsInfo = info?.reduce((result, group) => {
        result[group.groupId] = group;
        return result;
      }, {});
      this.productsGroupMap = {
        ...servicesData,
        ...softwareData,
        ...relatedProductsInfo
      };
    return this.relatedProducts;
    } catch(error) {
      console.log('Cannot fetch related products ',error);
    }
  }

  getProductsGroup(groupId) {
    return this.productsGroupMap[groupId];
  }

  relatedProductToRelatedProductInfo({ info, services, software }) {
    const mappedGroupsInfo = info?.length ? { info: info.map(this.mapGroupInfo)}: {};
    const mappedServicesInfo = services? { services: this.mapGroupInfo(services)}: {};
    const mappedSoftwarInfo = software? { software: this.mapGroupInfo(software)}: {}; 
     return {
      ...mappedGroupsInfo,
      ...mappedServicesInfo,
      ...mappedSoftwarInfo
    };
  }

  mapGroupInfo(group) {
    const { groupId, viewProductLabel, popupLabel, products } = group;
    const { product: { skuId, name, description, imageLink }, url, price, currency } = group.products[0];
  
    return {
      groupId,
      viewProductLabel,
      popupLabel,
      productsCount: products.length,
      product: {
        skuId,
        name,
        description,
        url,
        price,
        currency,
        imageUrl: imageLink.url,
        imageTitle: imageLink.title
      }
    };
  }

}

// /** @type { { [productId: string]: RelatedProductsStore } } */
const instances = {};

/**
 * @param {string} productId
 * @param {'b2b' | 'b2c'} siteType
 * @returns {RelatedProductsStore}
 */
export function getRelatedProductsStore(productId, siteType, localeObj) {
  if (productId && !instances[productId]) {
    instances[productId] = new RelatedProductsStore(productId, siteType, localeObj);
  }

  return instances[productId];
}
